"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.breadcrumbTrailState = void 0;
exports.breadcrumbTrailState = [
    {
        identifier: '0',
        name: 'Skeletal System',
        isSelected: false,
    },
    {
        identifier: '1',
        name: 'Axial Skeleton',
        isSelected: true,
    },
    {
        identifier: '2',
        name: 'Free part of upper limb',
        isSelected: false,
    },
];
